export const actionTypes = {
    TOAST_ERROR: "TOAST_ERROR",
    TOAST_INFO: "TOAST_INFO",
    TOAST_MESSAGE: "TOAST_MESSAGE",
    TOAST_REMOVE: "TOAST_REMOVE",
    TOAST_SUCCESS: "TOAST_SUCCESS",
    TOAST_WARNING: "TOAST_WARNING",
};

export const actionCreators = {
    error: (message: string, duration: integer) => ({
        type: actionTypes.TOAST_ERROR,
        payload: { message, duration },
    }),
    info: (message: string, duration: integer) => ({
        type: actionTypes.TOAST_INFO,
        payload: { message, duration },
    }),
    message: (message: string, style: any) => ({
        type: actionTypes.TOAST_MESSAGE,
        payload: { message, style },
    }),
    remove: (toast: any) => ({
        type: actionTypes.TOAST_REMOVE,
        payload: { toast },
        saveReduxState: true,
    }),
    success: (message: string, duration: integer) => ({
        type: actionTypes.TOAST_SUCCESS,
        payload: { message, duration },
    }),
    warning: (message: string, duration: integer) => ({
        type: actionTypes.TOAST_WARNING,
        payload: { message, duration },
    }),
};

export default {
    create: actionCreators,
    type: actionTypes,
};
